import React from 'react';
import { Box, MenuItem, Table, TableBody, TableHead, TableRow, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  CustomButton,
  PaginationTable,
  FormTitleBox,
  DialogBody,
  HorizontalForm,
  CustomSelect,
  CustomTextField,
} from '../../../common/components';
import { formatDateForDisplay, getNameByUuid } from '../utils/contractsUtils';
import { usePlans } from '../../../hooks/usePlans';
import CloseIcon from '@mui/icons-material/Close';
/**
 * Tabla para editar contratos con filtros y paginación
 */
const ContractEditTable = ({
  contracts = [],
  filterInputs = {},
  page,
  totalPages,
  totalCount,
  rowsPerPage,
  groups = [],
  isArchived = false,
  onFilterChange,
  onPageChange,
  onRowsPerPageChange,
  onEdit,
  onClose,
}) => {
  const { data: plans = [] } = usePlans();

  /**
   * Maneja el cambio de filtros
   */
  const handleFilterInputChange = (event) => {
    const { name, value } = event.target;
    onFilterChange(name, value);
  };

  return (
    <Box>
      <FormTitleBox
        title="Filtros de contratos"
        buttonText="Salir"
        buttonIcon={CloseIcon}
        onButtonClick={onClose}
        showButton
        buttonProps={{ variant: 'danger', sx: { minWidth: '120px' } }}
      />
      <DialogBody>
        <HorizontalForm sx={{ pt: 0, pl: 0 }}>
          <CustomSelect
            label="Grupo"
            size="medium"
            variant="outlined"
            name="groupUuid"
            value={filterInputs?.groupUuid || 0}
            onChange={handleFilterInputChange}
            sx={{ maxWidth: '200px', mr: 2 }}
          >
            <MenuItem value={0}>Todos</MenuItem>
            {groups.map((group) => (
              <MenuItem key={group?.uuid} value={group?.uuid}>
                {group?.name}
              </MenuItem>
            ))}
          </CustomSelect>

          <CustomTextField
            label="DNI"
            size="medium"
            variant="outlined"
            name="dni"
            value={filterInputs?.dni || ''}
            onChange={handleFilterInputChange}
            sx={{ maxWidth: '200px', mr: 2 }}
          />

          <CustomTextField
            size="medium"
            label="N° contrato"
            variant="outlined"
            name="contractNumber"
            value={filterInputs?.contractNumber || ''}
            onChange={handleFilterInputChange}
            sx={{ maxWidth: '200px', mr: 2 }}
          />

          <CustomTextField
            size="medium"
            label="Nombre"
            variant="outlined"
            name="name"
            value={filterInputs?.name || ''}
            onChange={handleFilterInputChange}
            sx={{ maxWidth: '200px' }}
          />
        </HorizontalForm>

        <GeneralTableBox>
          <Table aria-label="contracts table">
            <TableHead>
              <TableRow>
                <HeadTableCell>N°</HeadTableCell>
                <HeadTableCell>Suscriptores</HeadTableCell>
                <HeadTableCell>Fecha Suscripción</HeadTableCell>
                <HeadTableCell>Plan</HeadTableCell>
                <HeadTableCell>Grupo</HeadTableCell>
                <HeadTableCell>Ult. cta emit.</HeadTableCell>
                <HeadTableCell>Acciones</HeadTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {contracts.map((contract, key) => (
                <TableRow key={key}>
                  <RowTableCell>{contract.contract_number}</RowTableCell>

                  <RowTableCell>
                    {contract.subscribers && contract.subscribers.length > 0
                      ? contract.subscribers.map((subscriber, index) => (
                          <React.Fragment key={subscriber.subscriber?.id || index}>
                            {subscriber.subscriber?.last_name}, {subscriber.subscriber?.first_name}
                            {index < contract.subscribers.length - 1 && ', '}
                          </React.Fragment>
                        ))
                      : 'SIN SUSCRIPTOR'}
                  </RowTableCell>

                  <RowTableCell>
                    {formatDateForDisplay(contract.initial_subscription_date)}
                  </RowTableCell>

                  <RowTableCell>{getNameByUuid(plans, contract.uuid_plan)}</RowTableCell>

                  <RowTableCell>{getNameByUuid(groups, contract.uuid_group)}</RowTableCell>

                  <RowTableCell sx={{ textAlign: 'center' }}>
                    {contract.last_generated_fee || '0'}
                  </RowTableCell>

                  <RowTableCell sx={{ textAlign: 'center' }}>
                    <CustomButton variant="contained" onClick={() => onEdit(contract)}>
                      <IconButton size="small">
                        {isArchived ? (
                          <VisibilityIcon sx={{ color: 'whitesmoke' }} />
                        ) : (
                          <EditIcon sx={{ color: 'whitesmoke' }} />
                        )}
                      </IconButton>
                    </CustomButton>
                  </RowTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          {totalCount > rowsPerPage && (
            <PaginationTable
              totalPages={totalPages}
              page={page}
              rowsPerPage={rowsPerPage}
              onPageChange={onPageChange}
              onRowsPerPageChange={onRowsPerPageChange}
              totalCount={totalCount}
            />
          )}
        </GeneralTableBox>
      </DialogBody>
    </Box>
  );
};

export default ContractEditTable;
